
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tracking",
      function () {
        return require("private-next-pages/tracking/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tracking"])
      });
    }
  